/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateProjectChangeOrderCommandResult } from '../../models/update-project-change-order-command-result';

export interface ApiProjectChangeOrderUpdateProjectChangeOrderPatch$Plain$Params {
      body?: {
'Id'?: string;
'No': string;
'ContractExtension'?: number;
'Date': string;
'Attachments'?: Array<Blob>;
}
}

export function apiProjectChangeOrderUpdateProjectChangeOrderPatch$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectChangeOrderUpdateProjectChangeOrderPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectChangeOrderCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectChangeOrderUpdateProjectChangeOrderPatch$Plain.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectChangeOrderCommandResult>;
    })
  );
}

apiProjectChangeOrderUpdateProjectChangeOrderPatch$Plain.PATH = '/api/ProjectChangeOrder/UpdateProjectChangeOrder';
